import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"currentColor\" clip-path=\"url(#a)\"><path d=\"M2.206 4.465v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1m6 1v4h-4v-4z\"></path><path fill-rule=\"evenodd\" d=\"M2.206 14.465v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1m6 5v-4h-4v4zM16.588 2.791l-3.713 3.712a.875.875 0 0 0 0 1.238l3.713 3.712a.875.875 0 0 0 1.237 0l3.712-3.712a.875.875 0 0 0 0-1.238l-3.712-3.712a.875.875 0 0 0-1.237 0m.618 6.806 2.475-2.475-2.475-2.475-2.475 2.475z\" clip-rule=\"evenodd\"></path><path d=\"M16.206 16.465v-2a1 1 0 1 1 2 0v2h2a1 1 0 0 1 0 2h-2v2a1 1 0 0 1-2 0v-2h-2a1 1 0 1 1 0-2z\"></path></g><defs><clipPath id=\"a\"><path fill=\"currentColor\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })